import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { API_URL } from '../../Actions/Config'
import PhotoGallery from "../Common/Gallery"
import DatePicker from "react-datepicker";
import AOS from "aos";
import Header from '../Common/Header'
import Footer from '../Common/Footer'
import Helmet from '../Common/Helmet'
import TourListing from "../Common/TourListing"
import { getMaldiveResortsDetails, getMaldivePrice } from "../../Actions/TourDetailsAction"
import { handleBooking } from "../../Actions/CheckoutAction"
import { tourFb, tourTw, tourLn } from "../../Images"
import "aos/dist/aos.css";
import "../../css/mainUpdate.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "react-datepicker/dist/react-datepicker.css";

const mapStateToProps = (state) => {
    return {
        tourDetailsReducer: state.TourDetailsReducer,
        CheckoutReducer: state.CheckoutReducer
    }
}

const mapDispatchToProps = dispatch => ({
    getMaldiveResortsDetails: (peram, type) => dispatch(getMaldiveResortsDetails(peram, type)),
    getMaldivePrice: (id, checkin, checkout) => dispatch(getMaldivePrice(id, checkin, checkout)),
    handleBooking: (data, tour) => dispatch(handleBooking(data, tour))
});


function getURL(tour) {
    var url = ""
    url = "/day-tours/" + tour.permalink + "/" + tour.id
    return url
}

function getImageURL(url, type = 0) {
    var image = ""

    switch (type) {
        case 0:
            image = API_URL + url
            break;

        default:
            break;
    }

    return image
}

const options = {
    items: 1,
    autoplay: true,
    autoplayTimeout: 3000,
    dots: true,
    nav: false
}

function getBannerImages(tour) {
    var image = []
    if (tour != null) {
        image = [
            tour[0].url,
            tour[1].url, ,
            tour[2].url, ,
            tour[3].url, ,
            tour[4].url,
        ].filter(Boolean);
    }

    return image
}

const buildUrl = (url, parameters) => {
    var qs = "";
    for (var key in parameters) {
        var value = parameters[key];
        if (!value) {
            continue
        }
        value = value.toString().split('\"').join('"');
        qs += key + "=" + encodeURIComponent(value) + "&";
    }
    if (qs.length > 0) {
        qs = qs.substring(0, qs.length - 1); //chop off last "&"
        url = url + "?" + qs;
    }
    return url;
}
const windowName = `sbg-window-${Math.random()}`;

const height = 400;
const width = 400;

const top = Math.max(0, (window.screen.height - height) / 2);
const left = Math.max(0, (window.screen.width - width) / 2);

const specs = `
      height=${height},
      width=${width},
      top=${top},
      left=${left},
      status=0,
      toolbar=0,
      directories=0,
      location=0,
      menubar=0,
      resizable=1,
      scrollbars=1`


class MadiveResortDetails extends Component {

    constructor(props) {
        super(props);

        const { peram } = this.props.match.params;
        this.state = {
            currentPage: 1,
            reviewsPerPage: 3,
            peram: peram,
            update: true,
            stars: 0,
            percentage: 0,
            tab: 1,
            checkin_date: "",
            checkout_date: "",
            price: null,
            contact_price: true,
            starting: true,
            adult: 0,
            child: 0,
            infant: 0,
            meals: 3,
            single: 0,
            double: 0,
            triple: 0,
        }
        this.props.getMaldiveResortsDetails(peram)
    }

    componentDidMount() {
        const savedState = sessionStorage.getItem("maldiveState");
        if (savedState) {
            const state = JSON.parse(savedState);

            if (state.date) {
            state.date = new Date(state.date);
            }
            this.setState(state);
        }
    }

    componentDidUpdate(prevProps) {
        const savedState = sessionStorage.getItem("maldiveState");
        if (
            prevProps.tourDetailsReducer.tour !== this.props.tourDetailsReducer.tour &&
            this.props.tourDetailsReducer.tour && !savedState
        ) {
            const tour = this.props.tourDetailsReducer.tour;

            this.setState({
                update: false,
                stars: tour.rating,
                percentage: tour.rating > 0 ? (tour.rating / 5) * 100 : 0,
                price: tour.tour_price,
                contact_price: tour.tour_price?.price > 0 ? true : false
            });
        }

        if (this.state.price !== null &&
            prevProps.tourDetailsReducer.price !== this.props.tourDetailsReducer.price &&
            this.props.tourDetailsReducer.price
        ) {
            this.setState({
                price: this.props.tourDetailsReducer.price
            });
        }
    }

    handleTabChange = (value) => {
        this.setState({
            tab: value
        })
    }

    handlePageChange = (pageNumber) => {
        this.setState({
            currentPage: pageNumber,
        });
    };

    handleDateChange = (value, name) => {
        let checkin_date = this.state.checkin_date;
        let checkout_date = this.state.checkout_date;

        if (name === "checkin_date") {
            checkin_date = value;

            checkout_date = new Date(value);
            checkout_date.setDate(checkout_date.getDate() + 1);

        } else if (name === "checkout_date") {
            checkout_date = value;
        }

        this.setState({
            checkin_date,
            checkout_date
        }, () => {

            const formattedCheckin = new Date(checkin_date)
                .toLocaleDateString("en-GB");

            const formattedCheckout = new Date(checkout_date)
                .toLocaleDateString("en-GB");

            this.props.getMaldivePrice(
                this.props.tourDetailsReducer.tour.id,
                formattedCheckin,
                formattedCheckout
            );
        });
    }


    handleBooking = () => {
        const { checkout_date, checkin_date, adult, single, double, triple } = this.state
        if (checkin_date == "" || checkout_date == "" || adult == 0 || (single == 0 && double == 0 && triple == 0)) {
            return false
        }
        sessionStorage.setItem(
            "maldiveState",
            JSON.stringify(this.state)
        );
        this.props.handleBooking({
            checkin_date: new Date(this.state.checkin_date).toLocaleDateString('en-GB'),
            checkout_date: new Date(this.state.checkout_date).toLocaleDateString('en-GB'),
            adult: this.state.adult,
            child: this.state.child,
            infant: this.state.infant,
            price: this.state.price,
            meals: this.state.meals,
            single: this.state.single,
            double: this.state.double,
            triple: this.state.triple,

        }, this.props.tourDetailsReducer.tour)
        
        setTimeout(() => {
            this.props.history.push("/maldive/resort/confirm-reserve")
        }, 1000);
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    handleFbShare = () => {
        const url = buildUrl('https://www.facebook.com/sharer/sharer.php', {
            'u': document.URL
        });
        window.open(url, windowName, specs);
    }
    handleTwitterShare = () => {
        const url = buildUrl('http://twitter.com/intent/tweet', {
            'url': document.URL
        });
        window.open(url, windowName, specs);
    }

    handleLinkedInShare = () => {
        const url = buildUrl('http://www.linkedin.com/shareArticle', {
            'mini': 'true',
            'url': document.URL
        });
        window.open(url, windowName, specs);
    }

    render() {

        const { reviewsList, images, tour, str_counts, categories, reviews } = this.props.tourDetailsReducer;
        const { currentPage, reviewsPerPage, adult_pax, child_pax } = this.state;
        var state = this.state

        const banners = tour != null ? getBannerImages(Object.values(tour.gallery_images)) : [];
        const indexOfLastReview = currentPage * reviewsPerPage;
        const indexOfFirstReview = indexOfLastReview - reviewsPerPage;

        const currentReviews = reviewsList.slice(
            indexOfFirstReview,
            indexOfLastReview
        );

        const totalPages = Math.ceil(reviewsList.length / reviewsPerPage);

        return <Fragment>
            <Header home={false} />
            <Helmet
                title={"Tour List"}
                description={"Listing"}
            />

            <div className='tour-details'>
                {tour != null ?
                    <div className='main-container'>

                        <div className="page-title">
                            <div className="container title-cont">
                                <div className="row">
                                    <div className="col-lg-12 title-inner tour-details-breadcrumb">
                                        <div className="breadcrumb-links">
                                            <a href="/">Home</a>
                                            <span className="sep"></span>
                                            <a href="/maldives">Maldives  Tours </a>
                                            <span className="sep"></span>
                                            <a>{tour.title}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="contentwrap">
                            <div className="introwrap">
                                <div className="tour-content-wrap">
                                    <div className='container'>
                                        <div className='row'>
                                            <div class="col-12 tour-sub-heading">
                                                <div class="tour-page-title">
                                                    <h4>{tour.title}</h4>
                                                </div>

                                                {reviews !== null && reviews.total_count > 0 ?
                                                    <div className="tour-info-wrap">
                                                        <div className="tour-info-value">
                                                            <div className="tourbox-bottom-col2 star-align">
                                                                <div className="star-rating" title="100%">
                                                                    <div className="back-stars-list">
                                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                                        <i className="fa fa-star" aria-hidden="true"></i>

                                                                        <div className="front-stars-list" style={{ width: this.state.percentage + "%" }}>
                                                                            <i className="fa fa-star" aria-hidden="true"></i>
                                                                            <i className="fa fa-star" aria-hidden="true"></i>
                                                                            <i className="fa fa-star" aria-hidden="true"></i>
                                                                            <i className="fa fa-star" aria-hidden="true"></i>
                                                                            <i className="fa fa-star" aria-hidden="true"></i>
                                                                        </div>
                                                                    </div>
                                                                    {state.stars > 0 ? state.stars : null}
                                                                    <span class="head-review-count" onClick={this.handleReviewTab}>  {reviews.total_count} reviews</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    : null}
                                                <div class="sub-heading-tag"><span>Location :</span> {tour.country?.name} </div>

                                            </div>
                                            <div className="col-lg-9 tours-wrap">
                                                <div className="tour-details-wrap">
                                                    <div className="slider-section-detail-page">
                                                        {state.stars > 0 ? <div className="tour-rating-badge"><span>{state.stars}</span>Rating</div> : <div className="tour-rating-badge"><span>No</span>Ratings yet</div>}

                                                        <div className="single-page" >
                                                            {banners.length > 0 ? (<PhotoGallery
                                                                key={tour.id + "-" + banners.length}
                                                                images={banners}
                                                            />
                                                            ) : null}
                                                        </div>
                                                    </div>

                                                    <p> <div dangerouslySetInnerHTML={{ __html: tour.description }} /></p>

                                                    <div className="tour-tabwrap review-tab">

                                                        <ul className="tabs">
                                                            <li onClick={() => this.handleTabChange(1)} className={"review-tab" + (this.state.tab == 1 ? " active" : "")} rel="tab1">Amenities</li>
                                                            <li onClick={() => this.handleTabChange(2)} className={"review-tab" + (this.state.tab == 2 ? " active" : "")} rel="tab4">Activity</li>
                                                            <li onClick={() => this.handleTabChange(3)} className={"review-tab" + (this.state.tab == 3 ? " active" : "")} rel="tab5">Tips to Maldives</li>
                                                            {this.props.tourDetailsReducer.reviewsList.length > 0 ?
                                                                <li onClick={() => this.handleTabChange(4)} className={"review-tab" + (this.state.tab == 4 ? " active" : "")} rel="tab6">Reviews ({this.props.tourDetailsReducer.reviews.total_count}) </li> : null}
                                                        </ul>
                                                        <div className="tab_container">
                                                            {this.state.tab == 1 ?
                                                                <div id="tab1" className="tab_content">
                                                                    <div class="tour-list">
                                                                        <div class="day-wrap">
                                                                        </div>
                                                                        <div class="tour-list-detail">
                                                                            {tour.amenities.length > 0 ? <ul> {tour.amenities.map((amenities) => (
                                                                                <li>{amenities.amenity?.name}</li>
                                                                            ))}</ul>
                                                                                : null}
                                                                        </div>

                                                                    </div>
                                                                </div> : null}

                                                            {this.state.tab == 2 ?
                                                                <div id="tab3" className="tab_content">
                                                                    <div className="tour-list">
                                                                        <div className="tour-list-detail">
                                                                            <p dangerouslySetInnerHTML={{ __html: tour.activity }} />
                                                                        </div>
                                                                    </div>


                                                                </div> : null}

                                                            {this.state.tab == 3 ?
                                                                <div id="tab5" className="tab_content">
                                                                    <div className="tour-list">
                                                                        <div className="tour-list-detail">
                                                                            {tour.trips.length > 0 ? <ul>
                                                                                {tour.trips.map((tour_trip) => (
                                                                                    <li>{tour_trip.trip?.item}</li>
                                                                                ))}
                                                                            </ul> : null}
                                                                        </div>
                                                                    </div>


                                                                </div> : null}
                                                            {this.state.tab == 4 && this.props.tourDetailsReducer.reviewsList.length > 0 ? (

                                                                <>
                                                                    <div id="tab6" className="tab_content">
                                                                        <div className="client-listing-review-wrap">

                                                                            <h2>Client Reviews</h2>

                                                                            <div className="client-ratings-and-stars">
                                                                                <div className="client-star-rating-view">

                                                                                    <h6>
                                                                                        {Number(
                                                                                            this.props.tourDetailsReducer.tour?.stars || 0
                                                                                        ).toFixed(1)}
                                                                                    </h6>

                                                                                    <div className="star-rates">
                                                                                        {[1, 2, 3, 4, 5].map((i) => {
                                                                                            const stars =
                                                                                                this.props.tourDetailsReducer.tour?.stars || 0;

                                                                                            if (i <= stars) {
                                                                                                return (<i key={i} className="fa-solid fa-star"></i>
                                                                                                );
                                                                                            } else {
                                                                                                return (
                                                                                                    <i key={i} className="fa-regular fa-star"></i>
                                                                                                );
                                                                                            }
                                                                                        })}
                                                                                    </div>

                                                                                    <span>
                                                                                        {
                                                                                            this.props.tourDetailsReducer.reviews.total_count
                                                                                        }{" "}
                                                                                        reviews
                                                                                    </span>
                                                                                </div>

                                                                                <div className="client-rating-count-view">

                                                                                    <h3 id='reviews-h3'>
                                                                                        Total review count and overall reviews
                                                                                    </h3>

                                                                                    <div className="all-stars">

                                                                                        {this.props.tourDetailsReducer.reviews.rate.map(
                                                                                            (rate, index) => (
                                                                                                <div className="single-star" key={index}>
                                                                                                    <h5>{rate.rate} Stars</h5>

                                                                                                    <div className="star-count-bar">
                                                                                                        <span className="highlighted-bar" style={{ width: `${rate.percentage}%`, }}></span>
                                                                                                    </div>

                                                                                                    <h6>{rate.count}</h6>
                                                                                                </div>
                                                                                            )
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <div id="scroll-review"></div>

                                                                            {currentReviews.length > 0
                                                                                ? currentReviews.map((review, pKey) => (
                                                                                    <div
                                                                                        className="single-client-reviews-listing"
                                                                                        key={pKey}
                                                                                    >
                                                                                        <div className="client-review-top-det">
                                                                                            <h4>
                                                                                                {review.booking.name}

                                                                                                <span>
                                                                                                    {" "}
                                                                                                    {review.booking.nationality}
                                                                                                </span>
                                                                                            </h4>

                                                                                            <div className="star-rates">
                                                                                                {[1, 2, 3, 4, 5].map((i) =>
                                                                                                    i <= review.rate ? (
                                                                                                        <i
                                                                                                            key={i}
                                                                                                            className="fa-solid fa-star"
                                                                                                        ></i>
                                                                                                    ) : (
                                                                                                        <i
                                                                                                            key={i}
                                                                                                            className="fa-regular fa-star"
                                                                                                        ></i>
                                                                                                    )
                                                                                                )}
                                                                                            </div>
                                                                                        </div>

                                                                                        <p>{review.review}</p>

                                                                                        <div className="added-client-images">
                                                                                            <div className="gallery">
                                                                                                {images
                                                                                                    ?.filter(
                                                                                                        (image) =>
                                                                                                            image.day_tour_review_id ===
                                                                                                            review.id
                                                                                                    )
                                                                                                    .map((image, key) => (
                                                                                                        <a
                                                                                                            key={key}
                                                                                                            href={`/uploads/review/day_tour/${image.name}`}
                                                                                                            data-lightbox={`group-${pKey}`}
                                                                                                            data-title=""
                                                                                                        >
                                                                                                            <img
                                                                                                                src={`/uploads/review/day_tour/${image.name}`}
                                                                                                                alt={`Thumbnail ${key}`}
                                                                                                            />
                                                                                                        </a>
                                                                                                    ))}
                                                                                            </div>
                                                                                        </div>

                                                                                        <h5>
                                                                                            Review on{" "}
                                                                                            {new Date(
                                                                                                review.created_at
                                                                                            ).toLocaleDateString("en-US", {
                                                                                                month: "short",
                                                                                                day: "2-digit",
                                                                                                year: "numeric",
                                                                                            })}
                                                                                        </h5>
                                                                                    </div>
                                                                                ))
                                                                                : null}
                                                                            <div className="pagination-wrapper">
                                                                                <button
                                                                                    disabled={currentPage === 1}
                                                                                    onClick={() =>
                                                                                        this.handlePageChange(currentPage - 1)
                                                                                    }
                                                                                >
                                                                                    « Previous
                                                                                </button>

                                                                                {[...Array(totalPages)].map((_, index) => (
                                                                                    <button
                                                                                        key={index}
                                                                                        className={
                                                                                            currentPage === index + 1 ? "active" : ""
                                                                                        }
                                                                                        onClick={() =>
                                                                                            this.handlePageChange(index + 1)
                                                                                        }
                                                                                    >
                                                                                        {index + 1}
                                                                                    </button>
                                                                                ))}

                                                                                <button
                                                                                    disabled={currentPage === totalPages}
                                                                                    onClick={() =>
                                                                                        this.handlePageChange(currentPage + 1)
                                                                                    }
                                                                                >
                                                                                    Next »
                                                                                </button>
                                                                            </div>







                                                                        </div>
                                                                    </div>
                                                                </>

                                                            ) : null}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="col-lg-3 col-priceform pr-gap">
                                                <div className="price-contents">
                                                    <div className="price-form-details">

                                                        <div className="price-form-title">
                                                            {state.price != null && !Array.isArray(state.price.discount) ?
                                                                <div class="discount_block" >
                                                                    <span>{state.price.discount.value} %off</span>
                                                                </div>
                                                                : null}
                                                            {state.price != null && state.price.offer != "" ? <div class="offer_block">Special Offer</div> : null}

                                                            {state.contact_price && state.price != null ? <div>
                                                                <div className="price-form-title-col1 text-uppercase" id="initial">
                                                                    {state.starting ? "Starting From" : "Total"}
                                                                </div>
                                                                <div class="price-form-title-col2">
                                                                    USD<br></br>
                                                                    {!Array.isArray(state.price.discount) ? <>

                                                                        <strike>{state.price.price}</strike><br />
                                                                        <span class="pricewrap1"> {state.price.discount.price}</span>
                                                                    </> : <span class="pricewrap1">{state.price.price}</span>}
                                                                </div>
                                                            </div>
                                                                : <span className="pricewrap1">Contact for pricing</span>}

                                                        </div>


                                                        <div className="col-wrap">
                                                            <div className="form-group price-chk">
                                                                <label id="label-bold">Check in</label>

                                                                <DatePicker selected={state.checkin_date} onChange={(date) => this.handleDateChange(date, "checkin_date")}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    className="form-control"
                                                                    minDate={new Date}
                                                                    placeholderText="DD/MM/YYYY"
                                                                />
                                                            </div>

                                                        </div>

                                                        <div className="col-wrap">
                                                            <div className="form-group price-chk">
                                                                <label id="label-bold">Check Out</label>

                                                                <DatePicker selected={state.checkout_date} onChange={(date) => this.handleDateChange(date, "checkout_date")}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    className="form-control"
                                                                    minDate={new Date}
                                                                    placeholderText="DD/MM/YYYY"
                                                                />
                                                            </div>

                                                            <div class="des-subfield">
                                                                <label id="selectedadult"><span
                                                                    class="t1">Adult </span><span
                                                                        class="t2">Age above 12 years </span></label>
                                                                <div class="select-drop-arrow"></div>
                                                                <select class="form-control ritsel" id="adultcount" name="adult" aria-labelledby="adultpax"
                                                                    data-error="Please select a adult" required value={this.state.adult} onChange={this.handleChange}>
                                                                    <option class="infantsoptions" value="">0</option>
                                                                    <option class="infantsoptions inf" value="1">1</option>
                                                                    <option class="infantsoptions inf" value="2">2</option>
                                                                    <option class="infantsoptions inf" value="3">3</option>
                                                                    <option class="infantsoptions inf" value="4">4</option>
                                                                    <option class="infantsoptions inf" value="5">5</option>
                                                                    <option class="infantsoptions inf" value="6">6</option>
                                                                    <option class="infantsoptions inf" value="7">7</option>
                                                                    <option class="infantsoptions inf" value="8">8</option>
                                                                    <option class="infantsoptions inf" value="9">9</option>
                                                                </select>
                                                                <div class="help-block with-errors"></div>
                                                            </div>

                                                        </div>

                                                        <div class="col-wrap">
                                                            <div class="des-subfield pax-boxes adultdropbox">
                                                                <label id="selectedchild">
                                                                    <span class="t1">Child </span>
                                                                    <span class="t2">Between 5 to 11 years</span>
                                                                </label>
                                                                <div class="select-drop-arrow"></div>
                                                                <select class="form-control ritsel" id="childcount" name="child" aria-labelledby="adultpax" value={this.state.child} onChange={this.handleChange}>
                                                                    <option class="infantsoptions" data-value="0">0</option>
                                                                    <option class="infantsoptions inf" data-value="1">1 </option>
                                                                    <option class="infantsoptions inf" data-value="2">2 </option>
                                                                    <option class="infantsoptions inf" data-value="3">3 </option>
                                                                    <option class="infantsoptions inf" data-value="4">4 </option>
                                                                    <option class="infantsoptions inf" data-value="5">5 </option>
                                                                    <option class="infantsoptions inf" data-value="6">6 </option>
                                                                    <option class="infantsoptions inf" data-value="7">7 </option>
                                                                    <option class="infantsoptions inf" data-value="8">8 </option>
                                                                    <option class="infantsoptions inf" data-value="9">9 </option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div class="col-wrap" style={{ marginTop: 10 }}>
                                                            <div class="des-subfield">
                                                                <label id="selectedinfants">
                                                                    <span class="t1">Infant </span>
                                                                    <span class="t2">Below 5 years</span>
                                                                </label>
                                                                <div class="select-drop-arrow"></div>
                                                                <select id="infantscount" class="form-control ritsel" name="infant" aria-labelledby="adultpax" value={this.state.infant} onChange={this.handleChange}>
                                                                    <option class="infantsoptions" data-value="0">0</option>
                                                                    <option class="infantsoptions inf" data-value="1">1 </option>
                                                                    <option class="infantsoptions inf" data-value="2">2 </option>
                                                                    <option class="infantsoptions inf" data-value="3">3 </option>
                                                                    <option class="infantsoptions inf" data-value="4">4 </option>
                                                                    <option class="infantsoptions inf" data-value="5">5 </option>
                                                                    <option class="infantsoptions inf" data-value="6">6 </option>
                                                                    <option class="infantsoptions inf" data-value="7">7 </option>
                                                                    <option class="infantsoptions inf" data-value="8">8 </option>
                                                                    <option class="infantsoptions inf" data-value="9">9 </option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div class="form-group price-chk">
                                                            <label>Meal Basis</label>
                                                            <div class="select-drop-arrow"></div>
                                                            <select class="form-control" id="location-select" name="meals" style={{ height: 35, padding: 0 }} value={this.state.meals} onChange={this.handleChange}>
                                                                <option value="3">Bed & breakfast</option>
                                                                <option value="2">Half board</option>
                                                                <option value="1">Full board</option>
                                                            </select>
                                                        </div>
                                                        <div class="form-group price-chk">
                                                            <label>Rooming</label>
                                                            <div class="row">
                                                                <div class="col-lg-4">
                                                                    <label>
                                                                        <span class="t1">Single </span>
                                                                    </label>
                                                                    <div class="select-drop-arrow"></div>
                                                                    <select class="form-control" id="single" name="single" value={this.state.single} onChange={this.handleChange} style={{ height: 35, padding: 0 }} data-equels="single">
                                                                        <option value="0">0</option>
                                                                        <option value="1">1</option>
                                                                        <option value="2">2</option>
                                                                        <option value="3">3</option>
                                                                        <option value="4">4</option>
                                                                    </select>
                                                                </div>
                                                                <div class="col-lg-4">
                                                                    <label>
                                                                        <span class="t1">Double </span>
                                                                    </label>
                                                                    <div class="select-drop-arrow"></div>
                                                                    <select class="form-control" id="double" name="double" value={this.state.double} onChange={this.handleChange} style={{ height: 35, padding: 0 }} data-equels="double">
                                                                        <option value="0">0</option>
                                                                        <option value="1">1</option>
                                                                        <option value="2">2</option>
                                                                        <option value="3">3</option>
                                                                        <option value="4">4</option>
                                                                    </select>
                                                                </div>
                                                                <div class="col-lg-4">
                                                                    <label>
                                                                        <span class="t1">Triple </span>
                                                                    </label>
                                                                    <div class="select-drop-arrow"></div>
                                                                    <select class="form-control" id="triple" name="triple" value={this.state.triple} onChange={this.handleChange} style={{ height: 35, padding: 0 }} data-equels="triple">
                                                                        <option value="0">0</option>
                                                                        <option value="1">1</option>
                                                                        <option value="2">2</option>
                                                                        <option value="3">3</option>
                                                                        <option value="4">4</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>



                                                        <div className="row quote-buttons" id="showprice">
                                                            <button disabled={state.price == null || parseInt(state.price.price) == 0} onClick={this.handleBooking} id="form-check" className="btn availability">Check Availability</button>
                                                        </div>

                                                        <div className="subfield-bottom">
                                                            <p>Share Tour with Friends</p>

                                                            <div className="socialwrap">
                                                                <ul>
                                                                    <script src='https://connect.facebook.net/en_US/all.js'></script>
                                                                    <li onClick={this.handleFbShare}><a id="fb_share"><img src={tourFb} alt="" width="23" height="23" /></a></li>
                                                                    <li onClick={this.handleTwitterShare}><a id="twitter_share"><img src={tourTw} alt="" width="23" height="23" /></a></li>
                                                                    <li onClick={this.handleLinkedInShare}><a id="linkedin_share"><img src={tourLn} alt="" width="23" height="23" /></a></li>
                                                                </ul>
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>
                                                <div className="maptani rm-pad">
                                                    <div id="gmap" style={{ width: "100%", height: 400 }}></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : null}
            </div>
            <Footer hyperLink={true} />
        </Fragment>
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps),withRouter)(MadiveResortDetails);